import React, { JSX } from 'react';
import {
  StyledBrandContainer,
  StyledBrandName,
  StyledLogoContainer
} from './style';
import { ComposeType } from '../../../Theme/CommonStyled';

type BrandContainerType = {
  logo?: string;
  children?: JSX.Element | string;
  brandName: string;
  logoStyle?: ComposeType;
  brandNameStyle?: ComposeType;
};

const BrandContainerWithLogo: React.FC<BrandContainerType> = ({
  logo,
  children,
  brandName,
  logoStyle,
  brandNameStyle
}) => {
  return (
    <StyledBrandContainer>
      <StyledLogoContainer {...logoStyle} logo={logo} />
      <StyledBrandName {...brandNameStyle}>{brandName}</StyledBrandName>
      {children}
    </StyledBrandContainer>
  );
};

export default BrandContainerWithLogo;
